export default __webpack_public_path__ + "static/media/logo.da0ca0f2.svg";